// extracted by mini-css-extract-plugin
export default {"ac-image":"lrGszU3DKzcQMSe6TgB8"};